import Vue from 'vue';

import App from './App.vue';
import router from './router';
import store from './store';

import Carousel from 'bootstrap-vue/es/components/carousel';
import Badge from 'bootstrap-vue/es/components/badge';
import NavBar from 'bootstrap-vue/es/components/navbar';
import FormPlugin from 'bootstrap-vue/es/components/';
import ToastPlugin from 'bootstrap-vue/es/components';
import AlertPlugin from 'bootstrap-vue/es/components';

import StoryblokVue from 'storyblok-vue';

import vueMny from 'vue-mny';
import VueCurrencyFilter from 'vue-currency-filter'

import * as moment from 'moment';

import inViewportDirective from 'vue-in-viewport-directive';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faShoppingCart)

Vue.directive('in-viewport', inViewportDirective)

import {
  basketFilters
} from './filters/basketFilters';

import './scss/custom.scss';
import './scss/skin/skin01.scss';

let hj = function (...params) { }

Vue.use(StoryblokVue);

Vue.config.productionTip = false

Vue.use(Carousel);
Vue.use(NavBar);
Vue.use(Badge);
Vue.use(FormPlugin);
Vue.use(ToastPlugin);
Vue.use(AlertPlugin);

basketFilters.init();

Vue.component('blok', function (resolve) {
  require(['./_storyblok/components/Blok.vue'], resolve)
})

Vue.component('lander', function (resolve) {
  require(['./_storyblok/page-types/Lander.vue'], resolve)
})

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.filter('optimizeImage', function (image, width, height, fit = false) {
  width = Math.ceil(width / 400) * 400;
  height = Math.ceil(height / 400) * 400;
  const param = [
    'https://img2.storyblok.com/',
    fit ? 'fit-in/' : '',
    `${Math.round(width)}x${Math.round(height)}`,
    '/smart',
    image.replace('//a.storyblok.com', '')
  ]
  if (width == 0 && height == 0) {
    //return '';
  }
  return param.join('');
});

Vue.filter('niceDate', function (input) {
  const date = moment(input);
  return date.format("dddd, MMMM Do");
});

Vue.filter('formatSbInternalLink', function (path) {
  if (path == undefined || path == null) {
    return '';
  } else if (path.search(/(http)s?(:\/\/)/) == 0) {
    return path;
  }
  const first = path.split(/\//)[0];
  const domains = store.getters['configuration/get']('domains');
  const domain = domains.data.datasource_entries.find(v => v.name == window.location.hostname);
  const domainRoute = domain ? domain.value : '';
  const contentPath = first == 'channels' ? path.replace('channels' + domainRoute, '') : path;

  if (window.location.pathname.split(/\//)[1] == 'channels') {

    return first == 'channels' ? '/' + path : path;
  }
  return contentPath;
});

Vue.filter('persons', function (count) {
  return count > 1 ? 'people' : 'person'
})

Vue.filter('pluralize', function (count, single, plural) {
  return count > 1 ? plural : single
});

Vue.filter('appendLegacyOnboardingQuery', function (
  path,
  profile,
  basket
) {
  const query = [
    `portion_count=${profile.people}`,
    profile.meal_plan ? `meal_plan=${profile.meal_plan}` : '',
    profile.shipping_date ? `delivery_weekday=${profile.shipping_date.day}` : '',
    profile.shipping_date ? `shipping_run_id=${profile.shipping_date.id}` : '',
  ].concat(
    profile.excluded_groups ? profile.excluded_groups.map(v => `excluded_foods%5B%5D=${v}`) : ''
  ).concat(
    basket.items.length > 0 ? basket.items.map(v => `recipe_ids%5B%5D=${v.recipe.id}`) : ''
  ).concat(
    basket.voucher.code ? `voucher_code=${basket.voucher.code}` : ''
  ).join("&");
  return `${path}?${query}`;
});

Vue.use(vueMny, {
  locale: 'en-US',
  style: "currency",
  currency: 'GBP',
  currencyDisplay: 'symbol',
});

Vue.use(VueCurrencyFilter,
  {
    symbol: '£',
    thousandsSeparator: ',',
    fractionCount: 2,
    fractionSeparator: '.',
    symbolPosition: 'front',
    symbolSpacing: false
  });

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')